import { render, staticRenderFns } from "./StringsForComp.vue?vue&type=template&id=1b65591a&scoped=true&"
import script from "./StringsForComp.vue?vue&type=script&lang=js&"
export * from "./StringsForComp.vue?vue&type=script&lang=js&"
import style0 from "./StringsForComp.vue?vue&type=style&index=0&id=1b65591a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b65591a",
  null
  
)

export default component.exports